const tokenKey = 'token'

export default class BackendService {
  constructor() {
    this.apiUrl = process.env.API_URL
    this.graphQlUrl = process.env.GRAPHQL_ENDPOINT
  }

  isLoggedIn() {
    return !!localStorage.getItem(tokenKey)
  }

  get token() {
    return localStorage.getItem(tokenKey)
  }

  set token(newToken) {
    localStorage.setItem(tokenKey, newToken)
  }

  validateCode(response) {
    return new Promise((resolve, reject) => {
      if (response.status >= 200 && response.status < 300) {
        resolve(response)
      }

      reject('Response with code: ' + response.status + '\nContent: ' + response.data.toString())
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/BackendService.js